import { openDialog } from 'vue3-promise-dialog'
import MsMessageBox from '@/components/messageBox/MsMessageBox.vue'
import { MSConstant } from '@/commons/wildcards/index'
import i18n from '@/i18ns/i18n'

const $t = i18n.global.t
const defaultConfig = Object.freeze({
  showCancelButton: true,
  showConfirmButton: true,
})

function getMsgOption (type, message, title, width) {
  if (typeof message === 'object' && message.message) {
    return { ...defaultConfig, ...message, type }
  } else {
    return {
      ...defaultConfig,
      type,
      message: message,
      title: title,
      width,
    }
  }
}

export const showAlert = (message, title, width) => {
  if (typeof message === 'object') {
    message.confirmButtonText ??= $t('i18nComponent.MessageBox.Close')
  }
  return openDialog(
    MsMessageBox,
    getMsgOption(
      MSConstant.MessageBoxType.Alert,
      message,
      title,
      width
    )
  )
}

export function showConfirm (message, title, width) {
  return openDialog(
    MsMessageBox,
    getMsgOption(
      MSConstant.MessageBoxType.Confirm,
      message,
      title,
      width
    )
  )
}

export const showInfo = showAlert
export const showSuccess = showAlert
export const showError = showAlert

export const showConfirmDelete = (options) => {
  return showConfirm({
    confirmButtonText: $t('i18nComponent.MessageBox.Delete'),
    ...options,
    confirmButtonType: 'danger',
  })
}
